import { useMutation } from '@tanstack/react-query'

import { ConfirmButton } from '@/components/confirm'
import { useT } from '@/lib/i18n/translate'

/** A row's delete: the trigger on the row's right edge, the error under it. */
export function ConfirmDeleteButton({
  label,
  confirmLabel,
  refusal,
  remove,
  onDeleted,
}: {
  label: string
  confirmLabel: string
  refusal?: string | undefined
  remove: () => Promise<void>
  onDeleted: () => void
}) {
  const t = useT()
  const mutation = useMutation({ mutationFn: remove, onSuccess: onDeleted })

  return (
    <ConfirmButton
      label={t('common.delete')}
      ariaLabel={`${t('common.delete')}: ${label}`}
      confirmLabel={t('common.confirmDelete')}
      confirmAriaLabel={confirmLabel}
      align="end"
      refusal={refusal}
      confirm={() => mutation.mutateAsync()}
      error={mutation.error}
    />
  )
}
